import { Component, OnInit, Injector, TemplateRef, ViewChild } from '@angular/core';
import { UntypedFormGroup, FormArray, UntypedFormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app/shared/common.service';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { HTTPStatus, AppTokenHandler, UserInfo } from 'src/app/Common/app-token-handler';
import { AppErrorHandler } from 'src/app/Common/app-error-handler';
import { ServiceRequestService } from 'src/app/shared/service-request.service';
import { observable } from 'rxjs';
import saveAs from 'file-saver';
import { DataService } from 'src/app/Common/data.service';


@Component({
  selector: 'app-create-service-request',
  templateUrl: './create-service-request.component.html',
  styleUrls: ['./create-service-request.component.scss']
})
export class CreateServiceRequestComponent implements OnInit {
  CreateServiceRequestForm: UntypedFormGroup;
  @ViewChild('decommissionedPopup') decommissionedPopup!: TemplateRef<any>;
  requesterList: any[] = [];   //for angular upgrade
  locationList: any;
  categoryList: any;
  categoryTooltip: string = '';
  subCategoryTooltip: string = '';
  itemTooltip: string = '';
  subcategoryList: any;
  itemList: any;
  filterList: any;
  IsVisisble: false;
  formData: FormData = new FormData();
  selectedFiles: FileList;
  UserInfo: UserInfo;
  attachmentList: any[] = [];
  SelectedCategory: any;
  TooltipText: any;
  popupRef: any;

  constructor(private _fb: UntypedFormBuilder, private _router: Router, private error: AppErrorHandler,
    private _activeRoute: ActivatedRoute, public _commonService: CommonService,
    injector: Injector, private _dialog: MatDialog, private appTokenHandler: AppTokenHandler,
    private status: HTTPStatus, private _serviceRequestService: ServiceRequestService, private _dataService: DataService,) {
  }

  ngOnInit() {

    this.CreateServiceRequestForm = this._fb.group({
      RequestEntityId: [''],
      RequisitionDate: [new Date()],
      RequestedforHead: ['', [Validators.required]],
      RequestedForGPN: [],
      RequestedForCUG: [],
      RequestedForphone: [],
      RequestedForName: [],
      ShortDescription: ['', [Validators.required]],
      LongDescription: [],
      RequesterName: [],
      RequesterHead: [, [Validators.required]],
      RequestedByGPN: [],
      RequesterCUG: [],
      RequesterMobileNumber: [],
      RequesterEmail: [],
      Requesterphone: [],
      CategoryID: ['', [Validators.required]],
      CategoryName: [],
      SubCategoryID: ['', [Validators.required]],
      SubCategoryName: [],
      ItemID: ['', [Validators.required]],
      ItemName: [],
      ReqLocation: ['', [Validators.required]],
      Location: [],
      attachmentList: [],
      attachementDTO: [],
      IsRequestedFor: false,
    });
    this.BindCategoryList();
    this.BindLocationList();
    IsVisisble: false;
    this.UserInfo = this.appTokenHandler.getLoginUserInfo();
    // this.requesterList = {
    //   EmployeeGPN: this.UserInfo.EmpGPN, EmployeeName: this.UserInfo.EmpName + '(' + this.UserInfo.EmpEmail + ')'
    // };
    // for angular upgrade
    this.requesterList = new Array<any>({
      EmployeeGPN: this.UserInfo.EmpGPN,
      EmployeeName: `${this.UserInfo.EmpName} (${this.UserInfo.EmpEmail})`,
    });
    this.CreateServiceRequestForm.controls.RequesterHead.setValue(this.requesterList[0]); // for angular upgrade
    this.CreateServiceRequestForm.controls.RequestedByGPN.setValue(this.UserInfo.EmpGPN);
    this.CreateServiceRequestForm.controls.RequesterCUG.setValue(this.UserInfo.EmpOfficePhone);
    this.CreateServiceRequestForm.controls.ReqLocation.setValue(this.UserInfo.EmpOffDescription);
  }
  OpenTooltipDialog(templateRef: any) {
    // console.log('Hello');
    // this.BindCategoryList();

    // console.log(this.BindCategoryList());
    // console.log("Tooltip button clicked!");
    const dialogTooltip = this._dialog.open(templateRef, {
      width: '570px',
      disableClose: false
    });
  }

  Exit() {

    debugger;
    this.SelectedCategory = "";
    this.TooltipText = "";
    this._dialog.closeAll();

  }

  BindCategoryList() {
    this._commonService.BindDropDown('category').subscribe(result => {
      this.categoryList = result;
      console.log(this.categoryList, 'BindCategoryList');

    });
  }
  BindLocationList() {
    this._commonService.BindDropDown('location').subscribe(result => {
      this.locationList = result;
    });
  }
  GetCategoryName(event) {
    if (event.originalEvent !== undefined) {
      this.CreateServiceRequestForm.controls.CategoryName.setValue(event.originalEvent.currentTarget.innerText);
    } else {
      const categoryList = this.requesterList.filter(x => x.value === event.value);
      this.CreateServiceRequestForm.controls.CategoryName.setValue(categoryList[0].label);
    }
  }
  GetSubCategoryName(event) {
    if (!this.checkValueIsNullOrEmptyOrUndefined(event)) {
      const selectedCategory = this.categoryList.find(category => category.value === event.value);
      this.categoryTooltip = selectedCategory ? selectedCategory.ToolTip : '';
      this._commonService.BindDropDownWithParam('subcategory', event.value).subscribe(result => {
        this.subcategoryList = result;
        console.log(this.subcategoryList, 'GetSubCategoryName');
      });
    }

  }
  GetItemName(event) {

    if (!this.checkValueIsNullOrEmptyOrUndefined(event)) {
      const selectedSubCategory = this.subcategoryList.find(category => category.value === event.value);
      this.subCategoryTooltip = selectedSubCategory ? selectedSubCategory.ToolTip : '';
      this._commonService.BindDropDownWithParam('item', event.value).subscribe(result => {
        this.itemList = result;
        console.log('Item list with IsDecommissioned:', this.itemList);
      });
    }

  }

  // ANMOL IS WORKING:


  OnItemSelected(event) {
    console.log('on OnItemSelected select ');
    if (!this.checkValueIsNullOrEmptyOrUndefined(event)) {
      const item = this.itemList.find(i => i.value === event.value);
      this.itemTooltip = item ? item.ToolTip : '';

      // ✅ Show popup based on SQL flag IsDecommissioned
      console.log(item?.IsDecommissioned,'on OnItemSelected select ');
      if (item?.IsDecommissioned === true || item?.IsDecommissioned === 1) {
        this.showDecommissionedPopup();
      }


    }
  }


  showDecommissionedPopup() {
    const dialogRef = this._dialog.open(this.decommissionedPopup, {
      width: '450px',
      //height: '350px',      // controls height (you can use px, %, vh)
      disableClose: true,
      position: {
        top: '100px',    // adjust vertically as per your form
        left: '550px'    // adjust horizontally to align beside “Items”
      },
      panelClass: 'decommissioned-popup'
    });

    this.popupRef = dialogRef;
  }


  closePopup() {
    if (this.popupRef) {
      this.popupRef.close();
    }

    // Reset selected item and stay on /CreateSr
    this.CreateServiceRequestForm.get('ItemID')?.reset();
  }



  // OnItemSelected(event) {

  //   if(!this.checkValueIsNullOrEmptyOrUndefined(event)){
  //     const item = this.itemList.find(category => category.value === event.value);
  //     this.itemTooltip = item ? item.ToolTip : '';
  //   }


  // }
  SearchActiveEmployee = (event) => {

    this._commonService.Autocomplete('FillCommonData/GetActiveEmployee', event.query).subscribe(result => {
      this.requesterList = this.filterDataList(event.query, result);
    }, (error) => {
      this.error.handleError(error);
    }, () => {
    });
  }
  filterDataList(query, dataList: any): any[] {
    const filtered: any[] = [];
    for (let i = 0; i < dataList.length; i++) {
      this.filterList = dataList[i];
      if (this.filterList.EmployeeName.toLowerCase().indexOf(query.toLowerCase()) === 0) {
        filtered.push(this.filterList);
      }
    }
    return filtered;
  }
  checkValueIsNullOrEmptyOrUndefined(value: any) {
    if (value == null || value == undefined || value == "") {
      return true;
    }
    else {
      return false;
    }
  }

  GetFormControls(controlName) {
    return this.CreateServiceRequestForm.controls[controlName];
  }
  SetEmployeeDetails(event) {
    console.log(event);
    this.CreateServiceRequestForm.patchValue({
      RequestedByGPN: event.EmployeeGPN,
      RequesterCUG: event.EmpCUG,
      Requesterphone: event.EmpMobile,
      RequesterName: event.EmpName,
      ReqLocation: event.EmpOffDescription
    })
    console.log(event);

  }
  SetRequesterforDetails(event) {
    console.log(event);
    this.CreateServiceRequestForm.patchValue({
      RequestedForGPN: event.value.EmployeeGPN,
      RequestedForCUG: event.value.EmpCUG,
      RequestedForphone: event.value.EmpMobile,
      RequestedforName: event.value.EmpName,
      ReqLocation: event.value.EmpOffDescription
    })

  }
  clearAutoComplete(controlName) {

    if (controlName === 'RequesterHead') {
      this.CreateServiceRequestForm.controls.RequesterCUG.reset();
      this.CreateServiceRequestForm.controls.RequestedByGPN.reset();
      this.CreateServiceRequestForm.controls.RequesterName.reset();
    }
    if (controlName === 'RequestedForHead') {
      this.CreateServiceRequestForm.controls.RequestedForCUG.reset();
      this.CreateServiceRequestForm.controls.RequestedForGPN.reset();
      this.CreateServiceRequestForm.controls.RequestedForName.reset();
    }
  }
  ShowRequestedForControl(value) {
    this.IsVisisble = value;
    if (value == false) {
      this.clearAutoComplete('RequestedForHead')
      this.CreateServiceRequestForm.controls.RequestedforHead.reset();
      this.CreateServiceRequestForm.controls.ReqLocation.setValue(this.UserInfo.EmpOffDescription);
    }

  }

  SubmitRequest() {
    if (this.GetFormControls('IsRequestedFor').value == false) {
      this.GetFormControls('RequestedforHead').clearValidators();
      this.GetFormControls('RequestedforHead').updateValueAndValidity();
      // this.GetFormControls('RequestedForCUG').clearValidators();
      // this.GetFormControls('RequestedForCUG').updateValueAndValidity();
    }
    else {
      this.GetFormControls('RequestedforHead').setValidators([Validators.required]);
      this.GetFormControls('RequestedforHead').updateValueAndValidity();
      // this.GetFormControls('RequestedForCUG').setValidators([Validators.required]);
      // this.GetFormControls('RequestedForCUG').updateValueAndValidity();
    }
    if (!this.CreateServiceRequestForm.valid) {
      alert('Please fill mandatory fields.');
      this.showErrorsOnInvalidForm();
      return false;
    }
    this.status.setHttpStatus(true);
    this.CreateServiceRequestForm.controls.attachmentList.setValue(this.attachmentList)
    this._serviceRequestService.AddServiceRequest(this.CreateServiceRequestForm.value).subscribe(data => {
      if (data.RequestIsSuccess) {
        if (data.RequestEntityId !== null) {
          alert(data.RequestMessage);
          this._router.navigate(['/ViewMyServiceRequest/1']);
        }
      } else {
        alert(data.RequestMessage);
      }
    }, (error) => {
      this.status.setHttpStatus(false);
      this.error.handleError(error);
    },
      () => { this.status.setHttpStatus(false); });
  }

  showErrorsOnInvalidForm() {
    Object.keys(this.CreateServiceRequestForm.controls).forEach(field => {
      const control = this.CreateServiceRequestForm.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }


  UploadAttachment(e) {
    this.formData = new FormData();
    if (e.target.files.length > 0) {
      const maxLength = 1024 * 1024 * 10;
      const fileList: FileList = e.target.files;
      const file: File = fileList[0];
      const fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1);
      if (fileExtension.toLowerCase() === 'docx' || fileExtension.toLowerCase() === 'doc'
        || fileExtension.toLowerCase() === 'pdf' || fileExtension.toLowerCase() === 'zip'
        || fileExtension.toLowerCase() === 'xls' || fileExtension.toLowerCase() === 'xlsx' || fileExtension.toLowerCase() === 'jpg'
        || fileExtension.toLowerCase() === 'jpeg' || fileExtension.toLowerCase() === 'png'
        || fileExtension.toLowerCase() === 'msg') {
        if (e.target.files[0].size > maxLength) {
          alert('File size cannot be more than 10 MB.');
          e.target.value = '';
          return;
        }
        this.formData.append('Attachments', file, file.name);
        this._serviceRequestService.UploadServiceRequestAttachment(this.formData).subscribe(path => {
          if (path.RequestIsSuccess == true) {
            this.CreateServiceRequestForm.controls.attachementDTO.setValue(path);

            this.attachmentList.push(this.CreateServiceRequestForm.controls.attachementDTO.value);

          } else {
            alert(path.RequestMessage);
          }

        });
      } else {
        alert('Please browse valid file extension.');
        e.target.value = '';
      }
    }
  }
  DeleteAttachment(attachmentName: string) {
    if (confirm('Are you sure! You want to delete the attachment?')) {
      this.attachmentList = this.attachmentList.filter(x => x.AttachmentName !== attachmentName);
    }
  }


  DownLoadFile = (attachmentData) => {
    console.log(attachmentData)
    this._dataService.PostDownload('ServiceRequest/DownLoadFile', attachmentData).subscribe(data => {
      const blob = new Blob([data], { type: 'application/octet-stream' });
      saveAs(blob, attachmentData.AttachmentName);
    },
    );
  }
}
